
<div class="branch-selector">
  <input type="text" [(ngModel)]="selectedBranch" (input)="filterBranches($event)" (focus)="toggleDropdown()" placeholder="Asignar sucursal..." />
  <div class="dropdown" *ngIf="showDropdown">
    <div class="option" *ngFor="let branch of filteredBranches" (click)="selectBranch(branch)">{{ branch.name }}</div>
  </div>
</div>